export const config = {
  rowSelectionType: 'radio',
  fieldControl: false,
  columns: [
    {
      title: '员工姓名',
      dataIndex: 'userName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '员工电话',
      dataIndex: 'userPhone',
      width: 120,
    },
    {
      title: '所属组织',
      dataIndex: 'orgNamePath',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '职位',
      dataIndex: 'roleName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
  ],
  search: [
    {
      name: 'userNameKeyword',
      label: '员工姓名',
    },
  ],
}
